import { useLayoutEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { generatePath, useNavigate } from 'react-router';

import { PATHS, toastErrors } from '@/shared/config';
import { useAppSelector } from '@/shared/hooks';
import { toastCaller } from '@/shared/ui';

import { organizationModel } from '@/entities/organization';
import { patientModel } from '@/entities/patient';
import { reportsModel } from '@/entities/reports';

export const useReportCheck = (reportID: string) => {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const formatMessageRef = useRef(formatMessage);
  const navigateRef = useRef(navigate);

  formatMessageRef.current = formatMessage;
  navigateRef.current = navigate;

  const isReportNotFoundAfterLoad = useAppSelector(
    reportsModel.selectors.selectIsReportNotFoundAfterLoad(reportID),
  );

  const patientID = useAppSelector(
    patientModel.selectors.selectCurrentPatientID,
  );

  const { isFDA: redirectToDeprecatedPatientProfile } = useAppSelector(
    organizationModel.selectors.selectFDAEnvironment,
  );

  useLayoutEffect(() => {
    if (isReportNotFoundAfterLoad) {
      toastCaller({
        type: 'error',
        heading: formatMessageRef.current(toastErrors.errorHeading),
        message: formatMessageRef.current(toastErrors.defaultError),
        autoClose: 10000,
      });

      navigateRef.current(
        generatePath(
          redirectToDeprecatedPatientProfile
            ? PATHS.patientProfile_DEPRECATED
            : PATHS.patient,
          {
            patientID,
          },
        ),
      );
    }
  }, [
    isReportNotFoundAfterLoad,
    patientID,
    redirectToDeprecatedPatientProfile,
  ]);
};
